import React from 'react';
import type { FlexProps } from '@withjoy/joykit';
import { Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { Feature } from './components/Feature';
import { Header } from './components/Header';
import { Photo } from './components/Photo';
import { Menu } from './components/Menu';
import { Skeleton } from './components/Skeleton';

interface StayZoneTileComponent
  extends React.FC<FlexProps>,
    Readonly<{
      Photo: typeof Photo;
      Header: typeof Header;
      Feature: typeof Feature;
      Menu: typeof Menu;
      Skeleton: typeof Skeleton;
    }> {}

const StayZoneTileRoot: React.FC<FlexProps> = ({ children, ...flexProps }) => {
  return (
    <Flex
      position="relative"
      flexDirection="column"
      backgroundColor="white"
      borderRadius={pxToRem(12)}
      boxShadow="0px 2px 8px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.04)"
      _hover={{
        boxShadow: '0px 7px 27px 0px rgba(44, 41, 37, 0.06), 0px 4px 16px 0px rgba(0, 0, 0, 0.07)',
      }}
      overflow="hidden"
      {...flexProps}
    >
      {children}
    </Flex>
  );
};

export const StayZoneTile = Object.assign(StayZoneTileRoot, {
  Photo,
  Header,
  Feature,
  Menu,
  Skeleton,
}) as StayZoneTileComponent;
